//@flow
import _ from 'underscore';
import Model from '../Model/model';
/*
  constructor(modelsAttributes): new Collection(modelsAttributes)
    the constructor receives the model's attributes data, this data is then
    parsed using the `parse` function, the data is used to instantiates all the
    models (using the model class returned on `__modelClass`) and store them
    in the `models` property (array);

  __modelClass(): This should return the models class.

  parse(data): this function parses the data recieved in the constructor, it
    should return an array with model's attributes that will be use to
    instantiate the models.
*/

export default class BaseCollection<ModelObject: Object, T: Model<ModelObject>, I> {
  models:T[];
  modelsAttrs:ModelObject[];

  constructor(modelsAttrs:?I) {
    this.models = [];
    this.__setModels(modelsAttrs);
  }

  +__modelClass:() => Class<T>;
  +__parse:<J:I>(modelAttrs:?I) => ModelObject[];

  __setModels(modelsAttributes:?I) {
    const ModelClass = this.__modelClass();
    this.modelsAttrs = this.__parse(modelsAttributes);

    _.each(this.modelsAttrs, (attrs) => {
      this.models.push(new ModelClass(attrs));
    });
  }

  empty():boolean {
    return !this.models.length;
  }

  getRawData():ModelObject[] {
    return this.modelsAttrs;
  }

  length():number {
    return this.models.length;
  }

  _getModelByAttribute(name:string, value:string|number|boolean):?T {
    return _.find(this.models, model => model.get(name) == value);
  }

  _getModelsByAttribute(name:string, value:string|number|boolean):T[] {
    return _.filter(this.models, model => model.get(name) === value);
  }

  _getModelsByVerb(verb:(T)=>boolean):T[] {
    return _.filter(this.models, model => verb(model));
  }

  _getModelsByAttributes(name:string, values:?string[]|number[]):T[] {
    const models = [];

    _.each(values, (value) => {
      const model = this._getModelByAttribute(name, value);

      if (model) models.push(model);
    });

    return models;
  }
}
